import CloseIcon from '@mui/icons-material/CloseRounded';
import { Button, Fade, styled } from '@mui/material';
import { MaterialDesignContent, SnackbarProvider, closeSnackbar } from 'notistack';
import React from 'react';
import {
  chromeYellow,
  kiwiGreen, sanguine, ultraMarine,
} from '../../../utils/colors';
import { AUDIO_WARNING_SNACKBAR_KEY } from '../AudioWarning';

const StyledMaterialDesignContent = styled(MaterialDesignContent)(({ theme }) => ({
  '&.notistack-MuiContent': {
    width: '100%',
    boxShadow: theme.shadows[2],
    display: 'flex',
    flexWrap: 'nowrap',
    '& .MuiButton-root': {
      padding: 4,
      minWidth: 0,
      width: 32,
      height: 32,
      color: 'inherit',
      '& svg': {
        fontSize: 16,
        color: 'inherit',
      },
    },
  },
  '&.notistack-MuiContent-error': {
    backgroundColor: sanguine[300],
    color: sanguine[600],
  },
  '&.notistack-MuiContent-success': {
    backgroundColor: kiwiGreen[300],
    color: kiwiGreen[700],
  },
  '&.notistack-MuiContent-info': {
    backgroundColor: ultraMarine[300],
    color: ultraMarine[600],
  },

  '&.notistack-MuiContent-warning': {
    backgroundColor: chromeYellow[400],
    color: chromeYellow[800],
  },
}));

function renderAction(snackbarId: string) {
  if (snackbarId === AUDIO_WARNING_SNACKBAR_KEY) {
    return null;
  } return (
    <Button onClick={() => closeSnackbar(snackbarId)}>
      <CloseIcon />
    </Button>
  );
}

export default function StyledSnackbarProvider(props: { children: React.ReactNode, domRoot?: HTMLDivElement }) {
  const {
    children, domRoot,
  } = props;
  return (
    <SnackbarProvider
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      dense
      classes={{
        containerRoot: 'SnackbarContainer-root',
      }}
      domRoot={domRoot}
      autoHideDuration={5000}
      maxSnack={3}
      TransitionComponent={Fade}
      transitionDuration={600}
      disableWindowBlurListener
      Components={{
        success: StyledMaterialDesignContent,
        info: StyledMaterialDesignContent,
        error: StyledMaterialDesignContent,
        warning: StyledMaterialDesignContent,
      }}
      action={renderAction}
    >
      {children}
    </SnackbarProvider>
  );
}
